import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AiOutlineLeft } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { trimString } from '../Helpers/Common';
import { Card, SubNavBarActiveDiv, SubNavBarNormalDiv, TextBlack, NavActiveLink, ButtonCommonTop, SubNavBarActiveDot, SubNavBarNormalDot } from '../../pages/Theme';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const NavTabs = ({ menuLinks, value, padding = true, isDot = true }) => {
    const location = useLocation();
    const history = useHistory();

    const isDefaultTheme = useSelector(state => state.auth.isDefaultTheme);

    const Tablink = ({ text, active, onChange }) => {
        let style = ` ${isDot ? 'text-lg' : 'text-md'} py-2 mr-3 px-4 pb-1 w-max font-bold  flex h-full items-center nav-navigate cursor-pointer sub-link`;
        return (
            active ?
                <div className="px-3 ">
                    <SubNavBarActiveDiv onClick={() => { onChange(); }} className={'h-full flex justify-center items-center border-b-2' + style}>
                        <SubNavBarActiveDiv className='flex'>
                            <span><div className='flex items-center'>
                                {isDot &&
                                    <SubNavBarActiveDot />
                                }
                                {text}</div></span>
                        </SubNavBarActiveDiv>
                    </SubNavBarActiveDiv>
                </div> :
                <div className={'h-full flex justify-center items-center px-3' + style}>
                    <SubNavBarNormalDiv onClick={() => { onChange(); }}>
                        <SubNavBarNormalDiv className='flex'>
                            <span><div className='flex items-center'>
                                {isDot &&
                                    <SubNavBarNormalDot />
                                }
                                {text}</div></span>
                        </SubNavBarNormalDiv>
                    </SubNavBarNormalDiv>
                </div >
        )
    }

    const TablinkDefault = ({ text, onChange, active, isDot }) => {
        let style = (active ? 'blueColor blueBorderColor ' : 'greyColor border-transparent ');
        style += `${isDot ? 'text-lg' : 'text-md '} py-2 mr-3 px-4 pb-1 w-max font-bold flex h-full items-center border-b-2 hover:no-underline hover:text-black cursor-pointer`
        let dotStyle = ` w-1.5 h-1.5 mr-3 rounded-full ${active ? ' blueBackGroundColor' : 'greyBackGroundColor'}`;
        return (
            <div onClick={() => { onChange(); }} className={'h-full flex justify-center items-center ' + style}>
                <span><div className='flex items-center'>
                    {isDot &&
                        <div class={dotStyle}>
                        </div>
                    }
                    {text}</div></span>
            </div>
        )
    }


    return (
        <div className={`flex h-full w-max justify-start overflow-x-auto no-scrollbar ${padding ? 'px-4' : 'px-0'}`}>
            {
                menuLinks.map((menu, idx) => (
                    isDefaultTheme === false ?
                        <Tablink
                            key={idx}
                            text={menu.title}
                            active={menu.index === value}
                            onChange={menu.onChange}
                            isDot={isDot}
                        /> :
                        <TablinkDefault
                            key={idx}
                            text={menu.title}
                            active={menu.index === value}
                            onChange={menu.onChange}
                            isDot={isDot}
                        />
                ))
            }
        </div>
    )
}

export default NavTabs;